import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeLayout } from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Footer from "./Footer";
import NewQuotation from "../Quotation/NewQuotation/NewQuotation";

class VendorQuotationLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidUpdate(prevProps) {
    // if (prevProps !== this.props) {
    //   if (this.props.isPreloader === true) {
    //     document.getElementById("preloader").style.display = "block";
    //     document.getElementById("status").style.display = "block";
    //     setTimeout(function () {
    //       document.getElementById("preloader").style.display = "none";
    //       document.getElementById("status").style.display = "none";
    //     }, 2500);
    //   } else {
    //     document.getElementById("preloader").style.display = "none";
    //     document.getElementById("status").style.display = "none";
    //   }
    // }
  }

  componentDidMount() {
    // Scroll Top to 0
    window.scrollTo(0, 0);
    let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    document.title = currentage + " | Vendpin";
  }

  render() {
    return (
      <React.Fragment>
        {/* <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div> */}

        <div id="layout-wrapper">
          <Header />

          <div>
            <NewQuotation byVendor={true} openId={0} token={this.props.match.params.token} />

            <Footer />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { VendorData } = state.VendorQuotation;
  return {
    VendorData,
  };
};
export default connect(mapStatetoProps, {
  changeLayout,
})(withRouter(VendorQuotationLayout));
